import { Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import ManagerBase from "./ManagerBase";

class NoteManager extends ManagerBase {
	constructor () {
		super("noteManager");

		this.remoteClassName = "note";
	}

	getListByTaskGuid (taskGuid, filters) {
		filters = {
			...filters,
			taskGuid,
		};
		
		const rd = NousCore.api.createRequest({ filters });
		const requestedAction = "get-list-by-task-guid";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}
}

const noteManager = new NoteManager();

Shark.registerController(noteManager);

export default noteManager;
